import { render, staticRenderFns } from "./GuestBookingOptions.vue?vue&type=template&id=45dfba75"
import script from "./GuestBookingOptions.vue?vue&type=script&lang=js"
export * from "./GuestBookingOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports